import { render, staticRenderFns } from "./AuctionHallPage.vue?vue&type=template&id=57043218&"
import script from "./AuctionHallPage.vue?vue&type=script&lang=js&"
export * from "./AuctionHallPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports